import { createContext } from "react"

const SmartAccountsContext = createContext({})
const ClientContext = createContext({})
const ArticleContext = createContext({})

export { SmartAccountsContext, ClientContext, ArticleContext }
